import React from 'react';
import UserTableList from '../components/UserTableList';
import PageLayout from '../components/layout/PageLayout';

const UserListPage = () => (
  <PageLayout>
    <UserTableList />
  </PageLayout>
);

export default UserListPage;